export enum FindingOriginType {
    FINDING = 'FINDING',
    FINDING_ASSESSMENT = 'FINDING_ASSESSMENT',
    FINDING_TEMPLATE = 'FINDING_TEMPLATE',
    FINDING_ENDPOINT = 'FINDING_ENDPOINT',
    FINDING_DEVICE = 'FINDING_DEVICE',
}
